const IPFS = window.Ipfs;

export const repo = "diffy-13234234"

export const ipfsNode = new IPFS({ repo });



// WEBPACK FOOTER //
// ./src/api.jsx